<template>
  <label>
    <span id="botao-carregamento-arquivos">
      <v-icon left dark>$TrayArrowUp</v-icon>
      <span>Carregar arquivos</span>
    </span>

    <v-file-input
      v-model="arquivos_de_cotacao"
      class="d-none"
      multiple
    />
  </label>
</template>

<script>

import {uploadArquivosCotacao} from "../../../../../api/compraPorDepartamentos/PedidoCompraTipo";
import {logout} from "../../../../../helpers";

export default {
  name: "CarregadorDeArquivosInput",
  data: () => ({
    arquivos_de_cotacao: null,
    carregando_dados: false
  }),
  watch: {
    arquivos_de_cotacao(arquivos) {
      if (arquivos.length > 0) {
        this.uploadArquivo();
      }
    },
    carregando_dados() {
      this.$emit('carregando_dados', this.carregando_dados);
    }
  },
  methods: {
    uploadArquivo() {
      this.carregando_dados = true;
      uploadArquivosCotacao(this.arquivos_de_cotacao).then(this.sucessoUpload).catch(logout)
    },
    sucessoUpload(cotacoes) {
      this.carregando_dados = false;
      this.$emit('cotacoes-para-analisar', cotacoes);
    }
  }
}
</script>

<style scoped>
#botao-carregamento-arquivos {
  background: #142454;
  color: white;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
}
</style>
